import { DatePipe } from '@angular/common';
import { Component, ElementRef, inject, viewChild, ViewEncapsulation } from '@angular/core';
import { DialogComponent } from 'app/shared/controls/dialog/dialog.component';
import { MarkdownComponent } from 'ngx-markdown';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'inpla-release-notes-dialog',
  imports: [DialogComponent, DatePipe, ProgressSpinner, MarkdownComponent],
  templateUrl: './release-notes-dialog.component.html',
  styleUrl: './release-notes-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ReleaseNotesDialogComponent {
  public readonly config: DynamicDialogConfig = inject(DynamicDialogConfig);
  private readonly dialogRef: DynamicDialogRef = inject(DynamicDialogRef);

  public readonly scrollContainer = viewChild<ElementRef>('scrollContainer');

  public shadowOpacity: number = 1;

  public acceptButtonClick(): void {
    this.config.data.onAccept();
  }

  public cancelButtonClick(): void {
    this.config.data.onCancel();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public handleScroll(): void {
    const container = this.scrollContainer().nativeElement;
    if (container.scrollHeight - container.scrollTop - 10 <= container.clientHeight) {
      this.shadowOpacity = 0;
    } else {
      this.shadowOpacity = 1;
    }
  }
}
